import InstitutionFeatureToggle from '@/models/Auth/Institutions/InstitutionFeatureToggle';

export default class UpdateInstitutionFeaturesRequest {
    featureToggles: InstitutionFeatureToggle[] = [];
}